import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/map-minus-one-plus-one-to-zero-one/definition"
import {ImageOpNodeMath} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/math/node"
import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"

@registerNode
export class ImageOpNodeMapMinusOnePlusOneToZeroOne extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeMapMinusOnePlusOneToZeroOne"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage} = await evaluator.getAll(this.parameters)

        let current: ValueOrNode<AnyImageOpResult> = sourceImage
        current = imageOpNodeBag.getNode("mul", ImageOpNodeMath, {
            operator: "*",
            operandA: current,
            operandB: 0.5,
        })
        current = imageOpNodeBag.getNode("add", ImageOpNodeMath, {
            operator: "+",
            operandA: current,
            operandB: 0.5,
        })

        return await evaluator.get(current)
    }
}
